import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'

import { wizard } from 'helpers/decorators'
import { apiCodeLists, apiCommon } from 'helpers/decorators/api'
import { Address, PersonalDetails } from 'components/forms'
import { FormattedMessage } from 'react-intl'
import { Button, FormDebug, Title } from 'components/misc'
import validate from './assessor-details.validation'

const enhance = compose(
  wizard({
    form: 'assessorRegistration',
    multipage: true,
    validate,
    destroyOnUnmount: false
  }),
  apiCommon({
    publicCountries: true,
    publicRegions: true
  }),
  apiCodeLists(['genders', 'titles'], {
    public: true
  })
)

class AssessorDetails extends Component {
  static propTypes = {
    values: PropTypes.object,
    codeLists: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    common: PropTypes.object.isRequired
  }

  render() {
    const { handleSubmit, onSubmit, codeLists, common, values } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h2>
          <FormattedMessage
            id="moduleTitle.personal_details"
            defaultMessage="Personal Details"
          />
        </Title>
        <PersonalDetails
          titles={codeLists.titles.list}
          genders={codeLists.genders.list}
          errors={this.props.errors}
        />
        <Title h2>
          <FormattedMessage id="moduleTitle.address" defaultMessage="Address" />
        </Title>
        <Address
          regions={common.regions.list}
          countries={common.countries.list}
        />
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
        <FormDebug values={values} />
      </form>
    )
  }
}

export default enhance(AssessorDetails)
